import * as SDK from '@siloreal:shared:sdk';
const { ok, err } = SDK.core;
type ValidationFn = SDK.validator.form.ValidationFn;

import * as v from 'valibot';

const DEFAULT_MESSAGES = {
  type: 'El email debe ser texto',
  required: 'El email es requerido',
  invalid: 'Debe ser un email válido',
  unknown: 'Error desconocido.',
};

const EmailSchema = v.pipe(
  v.string(DEFAULT_MESSAGES.type),
  v.nonEmpty(DEFAULT_MESSAGES.required),
  v.email(DEFAULT_MESSAGES.invalid)
);
const schema = {
  required: EmailSchema,
  optional: v.union([v.literal(''), EmailSchema]),
};

export const email: ValidationFn = (value, options = {}) => {
  const { required = false } = options;

  const effectiveSchema = required ? schema.required : schema.optional;
  const result = v.safeParse(effectiveSchema, value);

  return result.success //
    ? ok(result.output)
    : err(result.issues[0]?.message ?? DEFAULT_MESSAGES.unknown);
};
